<template>
  <div class="prose lg:prose-xl text-left w-full max-w-full px-4">
    <div ref="editorRef" class=""></div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useSystemStore } from '@/stores'

import Editor from '@toast-ui/editor'
import colorSyntax from '@toast-ui/editor-plugin-color-syntax'
import tableMergedCell from '@toast-ui/editor-plugin-table-merged-cell'

import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css'

const {
  initialValue = ''
} = defineProps<{
  initialValue?: string
}>()

const emit = defineEmits(['load', 'beforePreviewRender'])

const editorRef = ref<HTMLElement>()
let viewer : any = null

// Métodos do editor
const destroy = () => {
  if (!viewer) return

  viewer.destroy()
  viewer = null
}

onMounted(() => {
  if (viewer) return

  viewer = Editor.factory({
    el: editorRef.value as HTMLElement,
    viewer: true,

    plugins: [colorSyntax, tableMergedCell],
    autofocus: false,
    language: 'en',
    useCommandShortcut: true,
    usageStatistics: false,
    theme: useSystemStore().isDark ? 'dark' : 'light',
    events: {
      load: () => {
        emit('load')
      },
      beforePreviewRender: () => {
        emit('render')
      }
    }
  })

  viewer.setMarkdown(initialValue)
})

onUnmounted(destroy)
</script>

<style scoped lang="scss">
.toast-editor-wrapper {
  @apply w-full;

  .toast-editor-container {
    @apply border border-gray-300 rounded-lg overflow-hidden;
    :deep(.toastui-editor) {
      border: none;
    }
  }

  :deep(.toastui-editor-popup-body input[type='text'].tui-colorpicker-palette-hex) {
    height: 32px !important;
    width: 92px !important;
  }
}
</style>
